// Partner visits API (2026-10-06): see docs/superpowers/specs/2026-10-06-partner-visits-api-design.md

import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

// One line per vendor with pending suggestions on the open journal. The
// suggestions themselves render in the per-field AI cards (input.js).
// The editor reads the shared store list; the read view passes its own
// `pending` (derived locally) so it never touches the editor's card state.
// Spec: docs/superpowers/specs/2026-10-06-partner-visits-api-design.md §6.
@observer
class PartnerSuggestionsBanner extends Component {
    render() {
        const { stores, pending: pendingProp } = this.props;
        const { journalStore } = stores;
        const pending = Array.isArray(pendingProp) ? pendingProp : (journalStore.partnerPending || []);
        if (pending.length === 0) {
            return null;
        }
        return (
            <div class='mx-2 my-2'>
                {pending.map(p => (
                    <div
                        key={p.uuidv4}
                        class='alert alert-info py-2 px-3 mb-2 d-flex justify-content-between align-items-center flex-wrap gap-2'
                    >
                        <span>
                            <i class='fa-solid fa-message-bot me-2' />
                            <Text id='dyrejournal.partner.pending' fields={{ count: p.fields.length, vendor: p.clientName }}>
                                {p.fields.length} suggestions from {p.clientName} waiting
                            </Text>
                            <small class='text-body-secondary ms-2'>({p.fields.join(', ')})</small>
                        </span>
                        {p.source && p.source.url && (
                            <a class='btn btn-sm btn-outline-secondary' href={p.source.url} target='_blank' rel='noopener noreferrer'>
                                {p.source.label || <Text id='dyrejournal.partner.open-source'>Open recording</Text>}
                            </a>
                        )}
                    </div>
                ))}
            </div>
        );
    }
}

export default PartnerSuggestionsBanner;
